import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DEFAULT_RECOMMENDATION_LIMIT } from "../../constants";
import { HydratedRecommendation } from "../../recommendation.types";
import { requestGetResellerRecommendations } from "./getResellerRecommendations.request";

const useResellerRecommendations = (
  id: string,
  limit: number = DEFAULT_RECOMMENDATION_LIMIT,
  options?: QueryOptions<HydratedRecommendation[], ApiServiceError<ApiError>>
) => {
  const { data: recommendations, ...rest } = useQuery({
    queryKey: ["recommendation", "reseller", id, limit],
    queryFn: async () => await requestGetResellerRecommendations(id, { limit }),
    onError: toastServerError,
    enabled: Boolean(id),
    ...options
  });

  return { recommendations: recommendations ?? [], ...rest };
};

export default useResellerRecommendations;
